import React from 'react';
import { useSelector, useDispatch } from '~Hooks';

import * as actions from '~actions';

import OverlayWebpage from './Components/OverlayWebpage';

const Modules = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.modules);

  function handleCloseWebpage() {
    dispatch(actions.setModulesWebpage(null));
  }

  if (state.activeWebpage) {
    return <OverlayWebpage onClose={handleCloseWebpage} url={state.activeWebpage} />;
  }

  return null;
};

export default Modules;
